import { render, staticRenderFns } from "./PendingPost.vue?vue&type=template&id=5e206cd4&scoped=true"
import script from "./PendingPost.vue?vue&type=script&lang=js"
export * from "./PendingPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e206cd4",
  null
  
)

export default component.exports